module.exports = __webpack_public_path__ + "app/img/home_10@2x.2fb522b8.png";